var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 25.9102V29.25C51.6641 39.746 51.6641 44.9942 48.4033 48.2548C45.1427 51.5156 39.8945 51.5156 29.3984 51.5156C18.9023 51.5156 13.6543 51.5156 10.3935 48.2548C7.13281 44.9942 7.13281 39.746 7.13281 29.25C7.13281 18.7539 7.13281 13.5058 10.3935 10.2451C13.6543 6.98437 18.9023 6.98438 29.3984 6.98438H32.7383",
    stroke: "#215250",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2656 33.7031L22.2665 28.902C23.8519 26.9996 24.6446 26.0482 25.6874 26.0482C26.7303 26.0482 27.523 26.9996 29.1085 28.902L29.6883 29.598C31.2739 31.5004 32.0665 32.4518 33.1095 32.4518C34.1522 32.4518 34.945 31.5004 36.5303 29.598L40.5312 24.7969",
    stroke: "#EA7F4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9844 20.3438C48.6736 20.3438 51.6641 17.3531 51.6641 13.6641C51.6641 9.97498 48.6736 6.98438 44.9844 6.98438C41.2952 6.98438 38.3047 9.97498 38.3047 13.6641C38.3047 17.3531 41.2952 20.3438 44.9844 20.3438Z",
    stroke: "#EA7F4A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingIcon);
export default __webpack_public_path__ + "static/media/reporting-icon.0287075b9be68e9e1f68c07f52d41af5.svg";
export { ForwardRef as ReactComponent };